<template>
  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.67029 5.64598L0.20433 7.64696L4.6704 0.23554L4.67029 5.64598Z" fill="white"/>
    <path d="M4.65425 11.6008L0.0600918 8.81546L4.65421 15.2825L4.65425 11.6008Z" fill="white"/>
    <path d="M5.00493 11.6008L9.59909 8.81546L5.00497 15.2825L5.00493 11.6008Z" fill="white"/>
    <path d="M5.00379 5.64598L9.46974 7.64696L5.00367 0.23554L5.00379 5.64598Z" fill="white"/>
    <path d="M0.0600585 8.01034L4.64218 6.02106L4.64218 10.6916L0.0600585 8.01034Z" fill="white"/>
    <path d="M9.58398 8.01034L5.00187 6.02106L5.00187 10.6916L9.58398 8.01034Z" fill="white"/>
  </svg>
</template>